import { Gas } from "@domain/gas/gas";
import { Product } from "@domain/product/product";

import { TransmitterConfiguration } from "@domain/project/configurations/transmitter-configuration";
import { TransmitterType } from "@project/transmitter-configuration/transmitter-family-selector/transmitter-type";

export class OriginalTransmitterConfiguration {
  productConfiguration: TransmitterConfiguration;
  gas?: Gas;
  transmitter?: Product;
  family?: TransmitterType;
  attachments?: { product: Product; quantity: number }[];
  sensor?: Product;

  constructor(
    productConfiguration: TransmitterConfiguration,
    gas?: Gas,
    transmitter?: Product,
    attachments?: { product: Product; quantity: number }[],
    sensor?: Product,
    family?: TransmitterType,
  ) {
    this.productConfiguration = productConfiguration;
    this.gas = gas;
    this.transmitter = transmitter;
    this.family = family;
    this.attachments = attachments;
    this.sensor = sensor;
  }
}
